import React, { Component } from 'react';
import { connect } from 'react-redux';

import { actions } from '../actions';

class Options extends Component {
  render() {
    const { optionsOpen, formatting, polling, sort, toggleOptions, updateOptions } = this.props;
    const saveOptions = () => {
      updateOptions({
        formatting: this.formatting.value,
        polling: this.polling.value,
        sort: this.sort.value,
      });
      toggleOptions();
    };

    return (
      <div className={`options-container ${optionsOpen ? 'visible' : ''}`}>
        <div className="panel">
          <div className="panel-title user-details">
            <div className="user-username">Options</div>
          </div>
          <div className="panel-content">
            <div className="form-group group-narrow">
              <label>Formatting</label>
              <select defaultValue={formatting} ref={input => this.formatting = input}>
                <option value="standard">Default</option>
                <option value="compact">Compact</option>
                <option value="tiny">Tiny</option>
              </select>
            </div>

            <div className="form-group group-narrow">
              <label>Sorting</label>
              <select defaultValue={sort} ref={input => this.sort = input}>
                <option value="skill">Default</option>
                <option value="level">Level</option>
              </select>
            </div>

            <div className="form-group group-narrow">
              <label>Polling</label>
              <select defaultValue={polling} ref={input => this.polling = input}>
                <option value="30000">30 Seconds</option>
                <option value="300000">5 Minutes</option>
                <option value="600000">10 Minutes</option>
                <option value="900000">15 Minutes</option>
                <option value="1800000">30 Minutes</option>
                <option value="3600000">1 Hour</option>
              </select>
            </div>
          </div>
          <div className="panel-footer text-right">
            <div className="button primary" onClick={() => saveOptions()}>Save Options</div>
          </div>
        </div>

        <div className="options-toggle" onClick={toggleOptions}>
          <svg viewBox="0 0 24 24" height="100%" width="100%" preserveAspectRatio="xMidYMid meet">
            <g><path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"></path></g>
          </svg>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ app }) => ({
  optionsOpen: app.optionsOpen,
  formatting: app.formatting,
  polling: app.polling,
  sort: app.sort,
});

export default connect(
  mapStateToProps,
  actions
)(Options);



// WEBPACK FOOTER //
// ./src/components/Options.js